export default "__VITE_ASSET__yz8LZXVK__"